import { ApiError } from '@/lib/api'

function apiErrorDetail(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null
  try {
    const parsed = JSON.parse(err.message)
    if (parsed && typeof parsed.detail === 'string') return parsed.detail
  } catch {
    /* not JSON */
  }
  return err.message || null
}

export function formatUserbotSelectionError(err: unknown): string {
  const detail = apiErrorDetail(err)
  if (!detail) return 'Не удалось переключить юзербота.'
  if (/юзербот недоступен/i.test(detail)) {
    return 'Этот юзербот сейчас не подключен к Telegram. Подключите его через QR.'
  }
  return `Не удалось переключить юзербота: ${detail}`
}
